import utils from "../../../utils/utils.js";

export default {
    async shareFeed(_, data) {
        const shareData = {
            to: data.to,
            subject: data.subject,
            body: data.body,
            displayName: data.displayName,
            title: data.title,
            sourceId: data.sourceId,
            feedId: data.feedId,
            followerCount: data.followerCount,
            feedDate: new Date(data.feedDate).toISOString() // feedDate'i stringe dönüştür
        };

       await utils.utility.fetch("api/Editor/SendFeedEmail", "POST", null, shareData);
    
    }
};